export default __webpack_public_path__ + "static/media/1.83f95029.jpg";